import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-overlay',
  templateUrl: './lib-overlay.component.html',
  styleUrls: ['./lib-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibOverlayComponent {
  @Input() zIndexOverride?: number;
}
